/**
 * Created by Alex Aguilar on 7/7/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('adminFlightEditCtrl', adminFlightEditCtrl)
        .controller('adminFlightDeleteCtrl', adminFlightDeleteCtrl);

    adminFlightEditCtrl.$inject = ['$scope', '$stateParams', 'tabAdminFlights', 'loadForm', 'structureSeatMapService', 'linkService',
        'boardingGateService', 'dateService', '$filter', 'flightService', 'datePickerService', '$timeout','timeService','flightTimeService', '$uibModal', 'AuthServerProvider'];
    adminFlightDeleteCtrl.$inject = ['flight', 'dateParam', '$uibModalInstance', 'linkService', 'flightService', 'AuthServerProvider'];

    function adminFlightEditCtrl($scope, $stateParams, tabAdminFlights, loadForm, structureSeatMapService, linkService,
                                 boardingGateService, dateService, $filter, flightService, datePickerService, $timeout,
                                 timeService,flightTimeService, $uibModal, AuthServerProvider){
        var vm = this;
        vm.flightId = $stateParams.id;
        vm.dateParam = $stateParams.date;
        vm.type = $stateParams.type;
        vm.deleteFlight = deleteFlight;

        vm.datePickerService = datePickerService;
        vm.userAccount = AuthServerProvider.getUserAccount();
        vm.formFlights = {
            'stretches': [],
            'segments': [],
            'aircrafts': [],
            'boardingGates': [],
            'datePickerOpenStatus': []
        };

        vm.testLoad = {};

        vm.tomorrow = new Date();
        vm.tomorrow.setHours(0,0,0,0);

        vm.datepickerFlight = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.tomorrow
            },
            closed: function(args, index) {
                vm.formFlights.stretches[index].arrivalDate = args.closeDate;
                if(index == 0){
                    vm.formFlights.stretches[index].minDate = vm.tomorrow;
                }
            },
            open: function(index){
                if(vm.formFlights.stretches[index].minDate == undefined){
                    if(index == 0){
                        vm.formFlights.stretches[index].minDate = vm.tomorrow;
                        vm.datepickerFlight.datepickerOptions.minDate = vm.tomorrow;
                    }else{
                        vm.formFlights.stretches[index].minDate = vm.formFlights.stretches[index-1].arrivalDate;
                        vm.datepickerFlight.datepickerOptions.minDate = vm.formFlights.stretches[index-1].arrivalDate;
                    }
                }else{
                    vm.datepickerFlight.datepickerOptions.minDate = vm.formFlights.stretches[index].minDate;
                }
            }
        };

        vm.tabs = tabAdminFlights;
        vm.structures = (loadForm.data._embeddeds) ? loadForm.data._embeddeds.structures : [];
        vm.linkService = linkService;
        vm.flight = loadForm.data;
        vm.route = loadForm.data._embeddeds.flight._embedded.route;
        vm.statesFlight = (loadForm.data._embeddeds) ? loadForm.data._embeddeds.statesFlights : [];
        vm.aircrafts = [];

        var auxDepartureFlights = loadForm.data._embeddeds.flight._embedded.departureflights;
        getSegmentFlights(auxDepartureFlights);
        getDepartureFlights(auxDepartureFlights);
        vm.thereAreDepartureFlightConnection = thereAreDepartureFlightConnection(auxDepartureFlights);

        vm.openCalendar = function(index) {
            vm.formFlights.datePickerOpenStatus[index].open = true;
        };

        vm.getAircrafts = function(structure){
            angular.forEach(vm.formFlights.stretches, function(stretches, index) {
                if (structure != undefined) {
                    vm.formFlights.stretches[index].structure = structure;
                    var makerId = structure._embedded.modelAircraft.makerId,
                        modelId = structure._embedded.modelAircraft.modelAircraftId,
                        originAirportId = vm.formFlights.stretches[index].originAirportId,
                        destinyAirportId = vm.formFlights.stretches[index].destinyAirportId;
                    structureSeatMapService.getAircraftByStructure(structure.structureId)
                        .then(function (response) {
                            vm.formFlights.stretches[index].aircrafts = response;
                        });

                    flightTimeService.getFlightTimesByStructureAndStretch(makerId, modelId, originAirportId, destinyAirportId)
                        .then(function (response) {
                            vm.formFlights.stretches[index].flightTime = timeService.convertTimeToHourMinutes(response.data.time);
                        });
                } else {
                    vm.formFlights.stretches[index].structure = undefined;
                    vm.formFlights.stretches[index].aircrafts = [];
                    vm.formFlights.stretches[index].flightTime = undefined;
                }
            })
        }

        vm.getBoardingGates = function(airportId, index){
            boardingGateService.getBoardingGatesByAirport(airportId)
                .then(function(response){
                    return response.data._embedded.boardinggates;
                }).catch(function(error){
                })
        }

        vm.updateArrivalDate = function(index){
            /*$timeout(function(){
                vm.formFlights.stretches[index].arrivalDate = vm.formFlights.stretches[index].departureDate;
            }, 100);*/
        }

        vm.updateArrivalDateTime = function(pos){
            angular.forEach(vm.formFlights.stretches, function(stretches, index) {
                $timeout(function(){
                    var newTimeKey = "00:00";
                    if (vm.formFlights.stretches[index].flightTime != undefined) {
                        newTimeKey = vm.formFlights.stretches[index].flightTime;
                    }

                    var newTime = timeService.calculateSumTimes(vm.formFlights.stretches[index].departureDateTime, newTimeKey);
                    vm.formFlights.stretches[index].arrivalDateTime = newTime;

                    if(vm.formFlights.stretches[index].departureDate != undefined) {
                        vm.formFlights.stretches[index].arrivalDate =
                            changeDay(vm.formFlights.stretches[index].departureDateTime,
                                vm.formFlights.stretches[index].arrivalDateTime,
                                vm.formFlights.stretches[index].departureDate);
                    }

                    if(vm.formFlights.stretches[index+1] != undefined) {
                        if (
                            (parseInt(vm.formFlights.stretches[index].arrivalDateTime.replace(':', '')) >
                            parseInt(vm.formFlights.stretches[index + 1].departureDateTime.replace(':', '')))) {
                            vm.formFlights.stretches[index + 1].departureDateTime = vm.formFlights.stretches[index].arrivalDateTime;
                        }
                    }

                    if(index > 0){
                        vm.formFlights.stretches[index].minDate = vm.formFlights.stretches[index-1].arrivalDate;
                    }
                },100);
            });

            $timeout(function(){
                for (var i = pos + 1; i < vm.formFlights.stretches.length; i++) {
                    if (new Date(vm.formFlights.stretches[i - 1].arrivalDate).getTime() >
                        new Date(vm.formFlights.stretches[i].departureDate).getTime()) {
                        vm.formFlights.stretches[i].departureDate = vm.formFlights.stretches[i - 1].arrivalDate;
                    }
                    vm.formFlights.stretches[i].arrivalDate =
                        changeDay(vm.formFlights.stretches[i].departureDateTime,
                            vm.formFlights.stretches[i].arrivalDateTime,
                            vm.formFlights.stretches[i].departureDate);
                    vm.formFlights.stretches[i].minDate = vm.formFlights.stretches[i - 1].arrivalDate;
                }
            },100);
        }

        vm.saveFlight = function(isValid, formFlights){
            if(isValid){
                var updateForm = {
                    'departureFlights': getNewDepartureFlights(formFlights.stretches),
                    'segmentFlights': getNewSegmentFlights(formFlights.segments)
                }
                flightService.updateFlight(vm.flightId, updateForm, vm.userAccount.userName)
                    .then(function(response){
                        linkService.reloadRoute('adminFlights', {date: vm.dateParam, model: 'all', type: 'grid'})
                    });
            }
        }

        vm.autoCompleteAircraft = function(aircraft){
            angular.forEach(vm.formFlights.stretches, function(stretch, iterator){
                vm.formFlights.stretches[iterator].aircraft = aircraft;
            });
        }

        vm.autoCompleteBoardingGate = function(boardingGate, index){
            angular.forEach(vm.formFlights.stretches, function(stretch, iterator){
                if(stretch.aircraft == ""){
                    vm.formFlights.stretches[iterator].boardingGate = boardingGate;
                }
            });
        }

        if (vm.type === 'delete') {
            deleteFlight();
        }

        function deleteFlight() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/admin/configGeneral/adminFlight/adminFlight/adminFlightDelete.html',
                controller: 'adminFlightDeleteCtrl',
                controllerAs: 'vm',
                size: 'md',
                close: true,
                resolve: {
                    flight: [function () {
                        return vm.flight._embeddeds.flight;
                    }],
                    dateParam: [function () {
                        return vm.dateParam;
                    }]
                }
            });

            modalInstance.result.then(function () {
                linkService.reloadRoute('adminFlights', {date: vm.dateParam, model: 'all', type: 'grid'})
            }, function () {
            });
        }

        function getNewDepartureFlights(stretches){
            var data = [];
            angular.forEach(stretches, function(stretch){
                var aircraftId = linkService.getLinkId(stretch.aircraft._links.self.href),
                    boardingGateId = linkService.getLinkId(stretch.boardingGate._links.self.href),
                    structureId = stretch.structure.structureId,
                    auxDepartureDate = $filter('date')(stretch.departureDate, "dd/MM/yyyy"),
                    auxArrivalDate = $filter('date')(stretch.arrivalDate, "dd/MM/yyyy"),
                    departureDate = dateService.getDateToTimeTwo(auxDepartureDate, stretch.departureDateTime),
                    arrivalDate = dateService.getDateToTimeTwo(auxArrivalDate, stretch.arrivalDateTime);

                data.push({
                    'aircraftId': parseInt(aircraftId),
                    'arrivalDate': arrivalDate,
                    'boardingGateId': parseInt(boardingGateId),
                    'departureDate': departureDate,
                    'departureFlightId': stretch.departureFlightId,
                    'structureId': structureId
                })
            });
            return data;
        }

        function getNewSegmentFlights(segments){
            var res = [];
            angular.forEach(segments, function(segment){
                res.push({
                    'segmentFlightId': segment.segmentFlightId,
                    'state': segment.stateFlight.code
                })
            });
            return res;
        }

        function getDepartureFlights(departureFlights){
            angular.forEach(departureFlights, function(departureFlight, $index){
                var departureDate = dateService.getDateByDateZone(departureFlight.departureDate),// new Date(parseInt(departureFlight.departureDate)),
                    arrivalDate = dateService.getDateByDateZone(departureFlight.arrivalDate), // new Date(parseInt(departureFlight.arrivalDate)),
                    departureDateTime = dateService.convertTimeToZero(departureDate.getHours(), departureDate.getMinutes()),
                    arrivalDatTime = dateService.convertTimeToZero(arrivalDate.getHours(), arrivalDate.getMinutes()),
                    originAirportId = departureFlight._embedded.segment.originAirportId,
                    destinyAirportId = departureFlight._embedded.segment.destinyAirportId,
                    structure = (departureFlight._embedded.structure) ? departureFlight._embedded.structure : "",
                    boardingGate = (departureFlight._embedded.boardinggate) ? departureFlight._embedded.boardinggate : null,
                    aircraft = (departureFlight._embedded.aircraft) ? departureFlight._embedded.aircraft : null,
                    makerId = departureFlight._embedded.modelAircraft.makerId,
                    modelId = departureFlight._embedded.modelAircraft.modelAircraftId,
                    departureFlightIndex = $index;

                vm.formFlights.datePickerOpenStatus.push({'open': false});

                vm.formFlights.stretches.push({
                    'departureDate': departureDate,
                    'arrivalDate': arrivalDate,
                    'departureDateTime': departureDateTime,
                    'arrivalDateTime': arrivalDatTime,
                    '_embedded': departureFlight._embedded,
                    '_links': departureFlight._links,
                    'boardingGates': [],
                    'aircrafts': [],
                    'structure': structure,
                    'boardingGate': boardingGate,
                    'aircraft': aircraft,
                    'originAirportId': originAirportId,
                    'destinyAirportId': destinyAirportId
                });

                structureSeatMapService.getAircraftByStructure(structure.structureId)
                    .then(function(responseAircrafts){
                        vm.formFlights.stretches[departureFlightIndex].aircrafts = responseAircrafts;
                    });
                boardingGateService.getBoardingGatesByAirport(originAirportId)
                    .then(function(response){
                        vm.formFlights.stretches[departureFlightIndex].boardingGates = response.data._embedded.boardinggates;
                        var bgBool = false;
                        angular.forEach(response.data._embedded.boardinggates, function(bg, $index){
                            if (bg._links.self.href == boardingGate._links.self.href) {
                                bgBool = true;
                            }
                        });
                        if (!bgBool) {
                            vm.formFlights.stretches[departureFlightIndex].boardingGate = null;
                        }
                    });

                flightTimeService.getFlightTimesByStructureAndStretch(makerId, modelId, originAirportId, destinyAirportId)
                    .then(function (response) {
                        vm.formFlights.stretches[departureFlightIndex].flightTime = timeService.convertTimeToHourMinutes(response.data.time);
                    });
            });
        }

        function getSegmentFlights(departureFlights){
            angular.forEach(departureFlights, function(departureFlight, index){
                angular.forEach(departureFlight._embedded.segmentflights, function(segmentFlight){
                    segmentFlight.stateFlight = {
                        'code': segmentFlight.state
                    };
                    vm.formFlights.segments.push(segmentFlight)
                });
            });
        }

        function thereAreDepartureFlightConnection(departureFlights){
            var res = false;
            for(var i=0; i<departureFlights.length; i++){
                if(departureFlights[i]._embedded.departureFlightConnections != undefined){
                    res = true;
                    break;
                }
            };
            return res;
        }

        function getDatePickerOpenStatus(stretchRoutes){
            var stretchRoutesLength = stretchRoutes.length;
            for(var i = 0; i < stretchRoutesLength; i++){
                vm.specialFlightForm.datePickerOpenStatus.push({'open': false});
            }
        }

        function changeDay(timeDeparture, timeArrival, dateArrival){
            var timeDepartureSplit = timeDeparture.split(":"),
                timeArrivalSplit = timeArrival.split(":");
            if(parseInt(timeDepartureSplit[0])>parseInt(timeArrivalSplit[0])){
                dateArrival = new Date((dateArrival).getTime() + (1*24*60*60*1000));
            }
            return dateArrival;
        }
    }

    function adminFlightDeleteCtrl(flight, dateParam, $uibModalInstance, linkService, flightService, AuthServerProvider) {
        var vm = this;
        vm.flight = flight;
        vm.userAccount = AuthServerProvider.getUserAccount();
        vm.deleteFlight = function () {
            flightService.deleteFlightById(linkService.getLinkId(vm.flight._links.self.href), vm.userAccount.userName).then(function (response) {
                $uibModalInstance.close(true);
            });
        }

        vm.cancel = function () {
            $uibModalInstance.close(true);
        };
    }
})();

